const readEnvFlag = (name) => {
  if (typeof process === "undefined" || !process?.env) {
    return false;
  }
  return process.env[name] === "1";
};

export const isDebugFlagEnabled = (envVarName) => readEnvFlag(envVarName);

export const createDebugLogger = (envVarName) => {
  return (...args) => {
    if (readEnvFlag(envVarName)) {
      console.log(...args);
    }
  };
};
